import { IsDefined, Validate } from "class-validator";

import { IsGeofenceType } from "../validators/IsGeofenceType";
import { IsGeoJsonGeofenceCoordinates } from "../validators/IsGeoJsonGeofenceCoordinates";

import type { CoordinatesPair } from "./CoordinatesPair";

export class GeoJsonGeofence {
  /**
   * type = "Polygon"
   */
  @IsDefined()
  @Validate(IsGeofenceType)
  public type: "Polygon";

  /**
   * "coordinates": [[ longitude, latitude ][]]
   *  Example: [[[ 1, 2 ], [3, 4], [5, 6], [1, 2]]]
   */
  @IsDefined()
  @Validate(IsGeoJsonGeofenceCoordinates)
  public coordinates: [CoordinatesPair[]];
}
